const deleteSites = {
  toastr: 'Sitio eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteSites;
